import { Checkbox } from '@mui/material';
import { OnlyFansSubscriberHostessAutoReplyFreeloaders } from '../../../../types/hostessAutoReplyFreeloaders';

const FormRepeatRepliesCheckbox = (props: {
    formData: OnlyFansSubscriberHostessAutoReplyFreeloaders;
    setFormData: (formData: OnlyFansSubscriberHostessAutoReplyFreeloaders) => void;
}) => {
    const { formData, setFormData } = props;

    return (
        <Checkbox
            checked={formData && formData.repeatScriptWhenFinished ? true : false}
            size="medium"
            onChange={e => {
                setFormData({ ...formData, repeatScriptWhenFinished: e.target.checked });
            }}
            sx={{
                '& .MuiSvgIcon-root': {
                    fontSize: '1.5rem',
                },
            }}
        />
    );
};

export default FormRepeatRepliesCheckbox;
